import React from 'react'

import { Box, Typography } from "@mui/material"


export default function reportNameColumn() {

	return {
		name: 'name',
		label: 'Report name',
		options: {
			headerAlign: "left",
			filterType: "textField",
			customBodyRowRenderLite: value => <Box sx={{ display: "flex" }}>
				<Typography variant="subtitle1">
					{value}
				</Typography>
			</Box>
		},
	}
}